import { useLanguage, t } from "../../../i18n";
import React, { useMemo, useState } from "react";
import { Container, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Header from "../../../components/layout/Header/Header";
import MobileOffcanvasNav from "../../../components/layout/MobileOffcanvasNav/MobileOffcanvasNav";
import Footer from "../../../components/layout/Footer/Footer";
import ROUTES from "../../../config/routes";
import { useAuth } from "../../../features/auth/context/AuthContext";
import "./VerificationInfo.css";
function normalizeUser(sourceUser = {}) {
  return {
    id: sourceUser?.user_id || sourceUser?.id || "",
    user_id: sourceUser?.user_id || sourceUser?.id || "",
    name: sourceUser?.name || sourceUser?.full_name || "BaytBuddy User",
    full_name: sourceUser?.full_name || sourceUser?.name || "BaytBuddy User",
    email: sourceUser?.email || "",
    mobile: sourceUser?.mobile || "",
    profile_status: sourceUser?.profile_status || "",
    nafath_status: sourceUser?.nafath_status || ""
  };
}
export default function VerificationInfo() {
  useLanguage();
  const [showMobileNav, setShowMobileNav] = useState(false);
  const navigate = useNavigate();
  const {
    user: authUser
  } = useAuth();
  const user = useMemo(() => normalizeUser(authUser || {}), [authUser]);
  return <div className="bb-public-page">
      <Header onMenuClick={() => setShowMobileNav(true)} />

      <MobileOffcanvasNav show={showMobileNav} onHide={() => setShowMobileNav(false)} user={user} />


      <main className="bb-public-page__main">
        <Container>
          <section className="bb-verification-info__hero">
            <div className="bb-verification-info__hero-content">
              <span className="bb-verification-info__eyebrow">{t("Trust & Verification")}

              </span>
              <h1 className="bb-verification-info__title">{t("Why verification matters on BaytBuddy")}

              </h1>
              <p className="bb-verification-info__subtitle">{t("BaytBuddy is being built as a trust-led platform where stronger identity confidence supports safer interactions, more reliable listings, and more meaningful roommate discovery.")}



              </p>

              <div className="bb-verification-info__hero-actions">
                <Button onClick={() => navigate(ROUTES.NAFATH_VERIFICATION)}>{t("Start Verification")}

                </Button>
              </div>
            </div>
          </section>

          <section className="bb-verification-info__section">
            <h2>{t("Why Verification Matters?")}</h2>
            <p>{t("Roommate discovery and room-sharing decisions involve trust, safety, and personal comfort. Verification helps BaytBuddy encourage more serious participation by giving users a clearer trust framework before they access key platform actions.")}




            </p>
            <p>{t("In Phase 0, verification supports the platform’s trust-first direction by helping establish stronger credibility for users who want to post listings, engage responsibly, and participate in a more structured environment.")}




            </p>
          </section>

          <section className="bb-verification-info__section">
            <h2>{t("How Verification Works")}</h2>
            <p>{t("Users first complete their profile so BaytBuddy has the essential context needed for a more relevant and structured experience. After that, users are encouraged to proceed with the verification flow to unlock important trust-based capabilities on the platform.")}




            </p>
            <p>{t("This process is intended to make the platform more dependable by distinguishing more serious and accountable users from incomplete or low-intent participation.")}



            </p>
          </section>

          <section className="bb-verification-info__section">
            <h2>{t("Benefits of Being Verified")}</h2>
            <ul className="bb-verification-info__list">
              <li>{t("Build stronger credibility on the platform")}</li>
              <li>{t("Unlock key actions such as posting room availability")}</li>
              <li>{t("Support a more trusted and serious user ecosystem")}</li>
              <li>{t("Improve confidence for others interacting with your profile or listing")}


              </li>
              <li>{t("Contribute to a higher-quality roommate discovery experience")}

              </li>
            </ul>
          </section>

          <section className="bb-verification-info__section">
            <h2>{t("Safety, Privacy and Security")}</h2>
            <p>{t("BaytBuddy’s verification direction is designed to strengthen trust while respecting user privacy and platform responsibility. The goal is not only to support access control, but also to promote a safer environment where users can engage with more confidence.")}





            </p>
            <p>{t("As BaytBuddy grows beyond Phase 0, trust, privacy, safety, and verification-led interactions will continue to remain central to the product experience.")}



            </p>
          </section>
        </Container>
      </main>

      <Footer />
    </div>;
}
